import { render } from "./panelDetailsItem.vue?vue&type=template&id=fe1c2eea&scoped=true"
import script from "./panelDetailsItem.vue?vue&type=script&lang=js"
export * from "./panelDetailsItem.vue?vue&type=script&lang=js"

import "./panelDetailsItem.vue?vue&type=style&index=0&id=fe1c2eea&lang=scss&scoped=true"

import exportComponent from "D:\\projects\\gitlab\\DemoLab\\DemoLab-data\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe1c2eea"]])

export default __exports__